// extracted by mini-css-extract-plugin
export default {"ticketsContainer":"styles_ticketsContainer__aaqAW"};